<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Sponsors Management <span class="badge">{{sponsorsData ? sponsorsData.length : 0 }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewSponsors()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> NEW</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadSponsorsList($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="expandable" #dt [value]="sponsorsData" [paginator]="true" [rows]="10" [lazy]="true"
						scrollHeight="auto" scrollDirection="both" (onLazyLoad)="loadSponsorsList($event)"
						[totalRecords]="totalSponsorsDataCount" [loading]="loading"
						[rowsPerPageOptions]="paginationOption"
						styleClass="p-datatable-gridlines p-datatable-striped w-100">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="title" class="col-180 titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Title
										<p-sortIcon field="title"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="photo" class="col-180 viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Photo
									</div>
								</th>
								<th pSortableColumn="link" class="col-180 createdDateTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Link
										<p-sortIcon field="link"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status">
									<div class="col-150 p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="createdBy" class="col-180 CreatedByTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="createdBy"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" class="col-180 updatedTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updatedBy" class="col-180 ModifiedbyTD"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updatedBy"></p-sortIcon>
									</div>
								</th>
								<th class="text-nowrap p-element p-frozen-column actionTD">Action</th>
							</tr>
							<tr>
								<th [ngSwitch]="title" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'title', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['title'] ? dt.filters['title'].value : ''"
										[(ngModel)]="title" />
								</th>
								<th class="viewBtnTd">

								</th>
								<th [ngSwitch]="link">
								</th>

								<th [ngSwitch]="status">
									<p-dropdown #pDropDownId [options]="statuses"
										(onChange)="dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="created_at" class="show-col text-nowrap col-200 createdTD">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdBy">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'createdBy', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['createdBy'] ? dt.filters['createdBy'].value : ''"
										[(ngModel)]="createdBy" />
								</th>
								<th [ngSwitch]="updated_at" class="col-150 updated_atTD">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'updatedBy', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['updatedBy'] ? dt.filters['updatedBy'].value : ''"
										[(ngModel)]="updatedBy" />
								</th>

								<th class="text-nowrap p-element p-frozen-column actionTD">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-sponsorsData let-rowIndex="rowIndex">
							<tr>
								<td class="col-180 titleTD">
									{{sponsorsData.title}}
								</td>

								<td class="viewBtnTd">
									<p-galleria [effect]="slide" [(value)]="sponsorsData.photo"
										[(visible)]="sponsorsData.bannerVisible" [responsiveOptions]="responsiveOptions"
										[containerStyle]="{'max-width': '850px'}" [numVisible]="7" [circular]="true"
										[fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
										[baseZIndex]="100000">
										<ng-template pTemplate="item" let-item>
											<img [src]="sponsorsData.photo"
												style="width:100%; height:100%; display: block;" />
										</ng-template>
									</p-galleria>
									<button pButton *ngIf="sponsorsData.photo.length > 0" type="button" icon="pi pi-eye"
										label="View" (click)="sponsorsData.bannerVisible=true"></button>

									<!-- <img [src]="sponsorsData.photo" alt="Image not available"
										style="width: 100px; height: 100px;" /> -->
								</td>

								<td class="col-200 YoutubeTD">
									<span>{{sponsorsData.link}}</span>
								</td>

								<td class="col-150 statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="sponsorsData.status"
											(onChange)="changeStatus(sponsorsData)">

										</p-inputSwitch>
										<div class="label activeText" *ngIf="sponsorsData.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!sponsorsData.status">
											Inactive
										</div>
									</div>


									<!-- <p-inputSwitch [(ngModel)]="sponsorsData.status"
										(onChange)="changeStatus(sponsorsData)"></p-inputSwitch> -->
								</td>

								<td class="col-180 createdDateTD">
									{{sponsorsData.created_at | date: 'dd/MM/yyyy'}}
								</td>

								<td class="col-180 CreatedByTD">
									{{sponsorsData.createdBy}}
								</td>

								<td class="col-180 updatedTD">
									{{sponsorsData.updated_at | date: 'dd/MM/yyyy'}}
								</td>
								<td class="col-180 ModifiedbyTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{sponsorsData.updatedBy}}
								</td>


								<td class="text-nowrap p-element p-frozen-column actionTD" pfrozencolumn=""
									alignfrozen="right" style="width: 200px; right: 0px;">
									<ul class="actionList">
										<li>
											<button (click)="onEditSponsors(sponsorsData)" class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="onDelete(sponsorsData)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
									</ul>

									<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewseller(seller.id)"></button> -->
									<!-- <button pButton pRipple icon="pi pi-pencil"
										class="p-button-rounded p-button-success p-mr-2"
										(click)="onEditSponsors(sponsorsData)"></button>
									<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger" 
										(click)="onDelete(sponsorsData)"></button>-->
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">No Sponsors found.</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>

	</div>
</div>


<p-confirmDialog [style]="{width:'400px'}" id="confirmDialog"></p-confirmDialog>